import React, { useContext } from "react";
import HdfcHeader from "../components/pageBlocks/hdfcHeader";
import commonContext from "../../common/context/common";

function HigherLoanApplyThankYou() {
    window.scrollTo(0, 0);
    const { lead } = useContext(commonContext);
    return (
        <>
            <div className="wrapper">
                <HdfcHeader />
                <section className="higher-loan-thankyou mt-110">
                    <div className="container mx-auto px-5">
                        <h1 className="text-center text-xl md:text-3xl xl:text-5xl openSans-Light mb-5 md:mb-10">
                            Congratulations{" "}
                            <span className="openSans-Reg cust-name">
                                {lead.firstName} {lead.lastName}
                            </span>
                            !
                        </h1>
                        <p className="text-center font-42px leading-tight openSans-Light mb-4 md:mb-8">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit, sed do eiusmod tempor incididunt ut labore.
                        </p>
                        <p className="text-center text-base md:text-2xl leading-tight openSans-Light">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit, sed do eiusmod tempor.
                        </p>
                    </div>
                </section>
            </div>
        </>
    );
}

export default HigherLoanApplyThankYou;
